import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

function ScrollEffect(callback) {
  const [, setScrollPosition] = useState(0);
  let previousScrollTop = 0;

  function handleDocumentScroll() {
    const { scrollTop: currentScrollTop } = document.documentElement || document.body;

    setScrollPosition(previousPosition => {
      previousScrollTop = previousPosition;
      return currentScrollTop;
    });

    callback({ previousScrollTop, currentScrollTop });
  }
  const handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250);
  
  useEffect(() => {
    window.addEventListener('scroll', handleDocumentScrollThrottled, false);
    return () =>
      window.removeEventListener('scroll', handleDocumentScrollThrottled, false);
      // eslint-disable-next-line
  }, []);
}

export default ScrollEffect;